import React from "react";
import PropTypes from "prop-types";
import * as classes from "./MenuBurger.module.css";
import BurgerIcon from "../../assets/icons/inline/burger.svg";
import CloseIcon from "../../assets/icons/inline/close.svg";
import { SwitchTransition, CSSTransition } from "react-transition-group";

const MenuBurger = ({ burgerMenuOpen, setBurgerMenuOpen }) => {
  const icon = burgerMenuOpen ? CloseIcon : BurgerIcon;

  return (
    <SwitchTransition mode={"out-in"}>
      <CSSTransition
        key={burgerMenuOpen ? "CloseIcon" : "BurgerIcon"}
        addEndListener={(node, done) =>
          node.addEventListener("transitionend", done, false)
        }
        classNames={{
          enter: classes.menuiconEnter,
          enterActive: classes.menuiconEnterActive,
          enterDone: classes.menuiconEnterDone,
          exit: classes.menuiconExit,
          exitActive: classes.menuiconExitActive
        }}
      >
        <button
          className={classes.burgerButton}
          onClick={() => setBurgerMenuOpen(!burgerMenuOpen)}
        >
          <img src={icon} alt="menu icon" />
        </button>
      </CSSTransition>
    </SwitchTransition>
  );
};

MenuBurger.propTypes = {
  burgerMenuOpen: PropTypes.bool.isRequired,
  setBurgerMenuOpen: PropTypes.func.isRequired
};

export default MenuBurger;
